import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import AuthService from "../services/auth.service";

const BusinessRoute = () => {
  if (!AuthService.isLogin()) return <Navigate to="/login" />;
  const currentUser = AuthService.getCurrentUser();
  const businesses = currentUser.user?.businesses ?? [];
  if (businesses.length === 0) return <Navigate to="/not-a-business" />;
  return <Outlet />;
};

export default BusinessRoute;
